import styled from 'styled-components';

export const ErrorImage = styled(`img`)`
	margin-bottom: 24px;
	width: 192px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 260px;
		margin-bottom: 36px;
	}
`;
